export default {"src":"/login-app/[GIT_HASH]/_next/static/media/expand_more.7072a86f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};